import { defineMessages } from "react-intl";

const messages = defineMessages({
    close: {
        id: "general.close",
    },
    hint: {
        id: "intervalDragModal.hint",
    },
});

export default messages;
